import { render } from "./EditRole.vue?vue&type=template&id=4c8d4b54"
import script from "./EditRole.vue?vue&type=script&lang=js"
export * from "./EditRole.vue?vue&type=script&lang=js"

import "./EditRole.vue?vue&type=style&index=0&id=4c8d4b54&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__